<div class="rebranded-notification-card" (click)="onClickReadMore()" [ngClass]='{ "bg-lightBlue": !notification.viewed, "bg-white": notification.viewed}'>
  <img class="notifications-img" src="{{notificationImage}}" />
  @if (timeStamp) {
    <div class="timestamp"><span>{{timeStamp}}</span></div>
  }
  <div class="notification-container">
    @if (notification.subject) {
      <div class="text-container grid">
        <div class="notifications-title rebrandedTitle ellipsis">
          {{notification.subject}}
        </div>
      </div>
    }
    <div class="text-container">
      <multiline-ellipsis class="font12 font-noto" [text]="text" readMoreClass='font12 font-noto mR25 {{!notification.viewed ? "bg-unreaded" : "bg-white"}}' [maxLine]="notification.subject ? 2 : 3" (readMore)="onClickReadMore()"></multiline-ellipsis>
    </div>
    @if (notification.imageURLSigned) {
      <img class="img-container" src="{{notification.imageURLSigned}}" />
    }
    @if (notification.audioURLSigned) {
      <div class="mT10">
        <c-audio src="{{notification.audioURLSigned}}" [trackEvent]="notification.track" eventPrefix="Notification" (emitTrackEvent)="trackEvent($event)"></c-audio>
      </div>
    }
    @if (order?.get("type") === appConfig.Shared.Order.Type.REGIMEN && order?.get("products")?.length) {
      <img [src]='order?.get("regimen")?.get("regimenCoverImage") || "https://cdn.cureskin.com/app/img/Skin-Box.png"' style="width: 100px; display: block; margin: 15px auto 15px auto" />
      }@if (order?.get("type") === appConfig.Shared.Order.Type.PRODUCT) {
      <product-list [products]='order?.get("products")' [hideFooter]="true"></product-list>
    }
    @if (order?.get("type") === appConfig.Shared.Order.Type.REGIMEN && order?.get("products")?.length) {
      <div class="content">
        <div class="bold mB10">
          <translate-string [key]="order?.get('regimen')?.get('class')"></translate-string><span class="pL5" i18n="@@treatmentKit">Treatment kit</span>
        </div>
        @for (product of productInfo; track product) {
          <div>
            <li class="mB5">{{product.get('title')}}</li>
          </div>
        }
      </div>
    }
    @if (showPayButton) {
      <div class="w100">
        <cs-button [class]="'m2 primary btn-xxs'" style="margin: 0 auto; width: fit-content"><cs-button-text i18n="@@placeOrder">Place Order</cs-button-text></cs-button>
      </div>
    }
  </div>
</div>
@if (ui.dialog.open) {
  <pop-up [show]="true" (close)="closeReadMore()"><notification-dialog [notification]="notification" (close)="closeReadMore()"></notification-dialog></pop-up>
}
